.b1{overflow:hidden;}